import { CaseDetailLabels } from '../Case-Detail-Labels-model';
import { HelpPlanTypeModel } from '../help-plan-type.model';
import { IntakeHelpPlansModel } from '../intake-help-plans.model';
import { LocationType } from '../location-type.model';
import { ClientPolicyControlExceptionModel } from '../clientpolicycontrolexception.model';

import { Type } from 'class-transformer';
import { CaseTypeOrganizationUnits } from './case-type-organizationUnits.model';

export class CaseType {
    ctyId: string;
    ctyCode: string;
    ctyName: string;
    ctyDescription: string;
    ctyIsActive: boolean;
    @Type(() => Date) ctyStartDate: Date;
    @Type(() => Date) ctyEndDate: Date;
    ctyIsPublished: boolean;
    ctyIsAutomaticActions: boolean;
    ctyPublishedOn: string;
    ctyUnpublishedOn: string;
    ctyHasPiaPolicy: boolean;
    ctyHasVecozoPolicy: boolean;
    ctyHasTravelDetails: boolean;
    ctyHasFellowTravellers: boolean;
    ctyHasRehospitalisation: boolean;
    ctyHasAdl: boolean;
    ctyHasDbc: boolean;
    ctyHasPolicyStep: boolean;
    ctyHasInsureeStep: boolean;
    ctyHasCaseDetailsStep: boolean;
    ctyHasTravelStep: boolean;
    ctyHasFellowTravellersStep: boolean;
    ctyHasHelpPlansStep: boolean;
    ctyHasSummaryStep: boolean;
    ctyHasActionsStep: boolean;
    ctyHasLocationStep: boolean;
    ctyHasNoteStep: boolean;
    ctyHasRehospitalisationStep: boolean;
    ctyHasAdlStep: boolean;
    ctyHasDbcStep: boolean;
    ctyCaseDetailId: string;
    caseDetailLabel: CaseDetailLabels;
    caseDetailName: string = null;
    locations: LocationType[] = [];
    helpPlans: IntakeHelpPlansModel[] = [];
    helpPlanTypes: HelpPlanTypeModel[] = [];
    linkedCaseTypes: CaseType[] = [];
    clientPolicyControlExceptions: ClientPolicyControlExceptionModel[] = [];
    ctyDossierAssignmentTypeId: number;
    ctyDossierProductId: string;
    ctyHasLinkedDossier: boolean;
    assignmentId: string = null;
    caseTypeOrganizationUnits : CaseTypeOrganizationUnits[] = [];
}